import { MapPinIcon } from "@heroicons/react/20/solid";
import GetHeroIcon from "../../../utils/getHeroIcon";
import { IAgenda } from "../../agenda-creation/agenda";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { UtilityVenue } from "../../session-preview/venue";
import useTracking from "../../../components/molecules/analytics/hooks/useTracking";

const CalendarAgenda = ({ agenda }: { agenda: IAgenda }) => {
  const [track] = useTracking();
  const user = useSelector((state: RootState) => state.UserInfoSlice);
  const coSpeaker = agenda?.coSpeakers?.includes(user.profile.id);
  const speaker = agenda?.speakers?.includes(user.profile.id);
  const virtualVenue = agenda?.virtualVenue ?? null;
  const isAgendaRunning = isOver(agenda.startDate, agenda.endDate);
  const agendaSchedule =
    dayjs(agenda.startDate).format("MMM D, YYYY ") +
    dayjs(agenda.startDate).format("hh:mm A - ") +
    dayjs(agenda.endDate).format("MMM D, YYYY ") +
    dayjs(agenda.endDate).format("hh:mm A");

  function isOver(startDate: any, endDate: any) {
    const startD = new Date(startDate);
    const endD = new Date(endDate);
    const currentD = new Date();

    if (currentD >= startD && currentD <= endD) {
      return true;
    }
    return false;
  }

  return (
    <div className="flex w-full gap-2 rounded-xl bg-gradient-to-l from-[#c6f9d5] to-[#ddf9e6] dark:border-bkg dark:from-secondary-bg dark:to-profile-bkg">
      <div className="py-4 pl-3">
        <div className="w-2 h-full rounded-md bg-primary/70 dark:bg-gray-400" />
      </div>
      <div
        className={`w-full  rounded-xl p-4 flex flex-col gap-1 greenGradient`}
      >
        <div className="text-base font-medium text-primary dark:text-primary-light">
          {agenda.title}
        </div>
        <div className="flex flex-wrap items-start gap-2 sm:flex-nowrap">
          <div className="flex flex-col sm:gap-1">
            <div className="w-auto text-sm font-normal">{agendaSchedule}</div>
            {(coSpeaker || speaker) && !agenda?.enrollmentstatus && (
              <div className="flex gap-1">
                <GetHeroIcon
                  name="UserCircleIcon"
                  variant="solid"
                  className="w-4 h-4"
                  aria-hidden="true"
                />
                <div className="text-xs italic font-extralight">
                  {coSpeaker ? "You are the co-speaker" : "You are the speaker"}
                </div>
              </div>
            )}
          </div>
          <div>
            {virtualVenue.source != "na" ? (
              <button
                className={`rounded-full mx-2 py-1 px-4 capitalize text-white  text-xs ${
                  isAgendaRunning ? "bg-primary" : "bg-gray-400"
                }`}
                aria-label={`Join ${agenda.title}`}
                onClick={() => {
                  window.open(agenda.virtualVenue.url, "_blank");
                  track("onClick", {
                    eventName: "onClick",
                    object: {
                      id: agenda.id,
                      objectType: "TMS_AGENDA"
                    },
                    verb: {
                      id: "VIEWED",
                      display: {
                        "en-US": "Join"
                      }
                    }
                  });
                }}
                disabled={!isAgendaRunning}
                data-testid="calAgendaJoin"
              >
                {"Join".toUpperCase()}
              </button>
            ) : (
              <div className="flex items-center justify-end gap-1 text-center">
                <MapPinIcon
                  name="MapPinIcon"
                  className="flex-shrink-0 w-4 h-4"
                  aria-hidden="true"
                />
                <span className="text-xs">
                  <UtilityVenue ids={agenda.venue} />
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarAgenda;
